import { NgModule } from '@angular/core';
import { Routes, RouterModule, PreloadAllModules } from '@angular/router';
import { AuthGuardService } from './core/auth/guards/auth-guard.service';
import { LoginComponent } from './core/auth/login/login.component';
import { PersonaGuardService } from './features/guards/persona-guard.service';
import { EmpresaGuardService } from './features/guards/empresa-guard.service';
import { PerfilPageComponent } from './features/vista-perfil/components/perfil-page/perfil-page.component';
import { TerminosCondicionesComponent } from './features/terminos-condiciones/terminos-condiciones.component';
import { PersonaActualizadaGuard } from './features/guards/persona-actualizada-guard.service';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'main/principal',
    pathMatch: 'full'
  },
  {
    path: 'login',
    component: LoginComponent
  },
  {
    path: 'main',
    canActivate: [AuthGuardService, PersonaActualizadaGuard],
    loadChildren: () =>
      import('./features/navegacion/navegacion.module').then(
        (m) => m.NavegacionModule
      )
  },
  {
    path: 'registro',
    canActivate: [AuthGuardService],
    loadChildren: () =>
      import('./features/vista-usuario/vista-usuario.module').then(
        (m) => m.VistaUsuarioModule
      )
  },
  {
    path: 'perfil',
    canActivate: [AuthGuardService],
    component: PerfilPageComponent,
    loadChildren: () =>
      import('./features/vista-perfil/vista-perfil.module').then(
        (m) => m.VistaPerfilModule
      )
  },
  {
    path: 'roles',
    loadChildren: () =>
      import('./features/roles/roles.module').then((m) => m.RolesModule)
  },
  {
    path: 'empresas',
    canActivate: [PersonaGuardService, PersonaActualizadaGuard],
    loadChildren: () =>
      import('./features/empresas/empresas.module').then(
        (m) => m.EmpresasModule
      )
  },
  {
    path: 'actividades',
    canActivate: [PersonaGuardService, EmpresaGuardService, PersonaActualizadaGuard],
    loadChildren: () =>
      import('./features/actividades/actividades.module').then(
        (m) => m.ActividadesModule
      )
  },
  {
    path: 'tramite',
    canActivate: [PersonaGuardService, PersonaActualizadaGuard],
    loadChildren: () =>
      import('./features/vista-tramite/vista-tramite.module').then(
        (m) => m.VistaTramiteModule
      )
  },
  {
    path: 'terminos-condiciones',
    component: TerminosCondicionesComponent
  }

  /*{
    path: 'feature-list',
    loadChildren: () =>
      import('./features/feature-list/feature-list.module').then(
        (m) => m.FeatureListModule
      )
  },
  {
    path: 'settings',
    loadChildren: () =>
      import('./features/settings/settings.module').then(
        (m) => m.SettingsModule
      )
  },
  {
    path: 'examples',
    loadChildren: () =>
      import('./features/examples/examples.module').then(
        (m) => m.ExamplesModule
      )
  },*/
  /*{
    path: '**',
    redirectTo: 'about'
  }*/
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'enabled',
      preloadingStrategy: PreloadAllModules,
      relativeLinkResolution: 'legacy'
    })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
